"use client"
import PropTypes from 'prop-types';
import { signOut, fetchAuthSession, signInWithRedirect } from 'aws-amplify/auth';
import { useMemo, useState, useEffect, useContext, useCallback, createContext } from 'react';

import * as PolnApi from "../../utils/api-service";
import PageLoader from "../../components/Loader/pageLoader";
const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const getUser = useCallback(async () => {
        try {
            const session = await fetchAuthSession();
            const userAttr = session.tokens?.idToken.payload;

            if (userAttr) {
                let data;
                try {
                    let response = await PolnApi.request(`/poln/user`, { notify: false, skipThrow: true });

                    data = response?.body.data;

                    if (!data) {
                        response = await PolnApi.request('/poln/user', {
                            method: 'POST',
                            body: {
                                email: userAttr.email,
                                cognitoId: userAttr.sub
                            }
                        }, { notify: false, skipThrow: true });
                    }
                    setUser({ ...userAttr, ...data });
                    setIsAuthenticated(Boolean(data.cognitoId));
                } catch (e) {
                    console.log('Error: ', e.message);
                }
            }
        }
        catch (e) {
            console.log('Error fetching user data: ', e.message);
        }
        finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        getUser();
    }, [getUser]);

    const federationLogin = useCallback(async () => {
        console.log("In federation login")
        try {
            await signInWithRedirect({ provider: 'Google' });
        } catch (e) {
            console.log('Error: ', e.message);
        }
    }, []);

    const logout = useCallback(async () => {
        await signOut();
    }, []);

    const authContextValue = useMemo(() => ({
        isAuthenticated,
        federationLogin,
        logout,
        user,
        isLoading
    }), [isAuthenticated, federationLogin, logout, user, isLoading]);

    if (isLoading) return <PageLoader />;

    return (
        <AuthContext.Provider value={authContextValue}>
            {children}
        </AuthContext.Provider>
    );
};

AuthProvider.propTypes = {
    children: PropTypes.node.isRequired
}
